module.exports = __webpack_public_path__ + "static/media/bell.b790103a.svg";